import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'vc-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less']
})
export class LoaderComponent {
  @Input() messageToTheUser = '';
  @Output() isClosed = new EventEmitter<boolean>();

  onDismiss() {
    this.isClosed.emit(true);
  }
}
